module.exports = __webpack_public_path__ + "static/media/logo.4cf46f8d.svg";